<template>
    <div>
        <h1>Política de Privacidade</h1>
        <ul>
            <li>
                Essa Política de Privacidade aplica-se ao aplicativo Nossa Praia disponível em
                (com.ima.nossapraia) sendo sua utilização como ferramenta para acompanhar a
                balneabilidade das praias alagoanas junto ao Instituto do Meio Ambiente – IMA/AL
            </li>
        </ul>
        <ul>
            <li class="mt-2 mb-2"><b>1. Aceitação dos Termos</b></li>
            <li>
                <b>1.1</b> Para usar os Serviços, o usuário deverá primeiro concordar com os Termos.
                Não é permitido o uso dos Serviços por parte do usuário se ele não aceitar os Termos.
            </li>
            <li>
                <b>1.2</b> O usuário pode aceitar os Termos:
            </li>
            <ul>
                <li>
                    <b>(A)</b> clicando para aceitar ou concordar, no caso de essa opção ser disponibilizada pelo
                    IMA na interface do usuário do Serviço; ou
                </li>
                <li>
                    <b>(B)</b> usando efetivamente os Serviços. Nesse caso, o usuário compreende e aceita que o
                    IMA/AL considerará o uso dos Serviços uma aceitação dos Termos a partir desse momento.
                </li>
            </ul>
        </ul>
        <ul>
            <li class="mt-4 mb-2"><b>2. Termos de Uso</b></li>
            <li>
                <b>2.1.</b> O usuário concorda em usar os Serviços somente para os fins permitidos: (a) pelos Termos; e
                (b)
                pelas leis, normas, práticas ou diretrizes geralmente aceitas nas jurisdições relevantes e aplicáveis.
            </li>
            <li>
                <b>2.2.</b> O usuário concorda em não participar de atividades que interfiram ou interrompam o
                funcionamento dos
                Serviços (ou servidores e redes conectados aos Serviços).
            </li>
            <li>
                <b>2.3.</b> O usuário concorda que será o único responsável por qualquer violação das suas obrigações no
                que diz
                respeito aos Termos e pelas consequências resultantes dessa violação.
            </li>

            <li>
                <b>2.4.</b> O Software usado pelo usuário pode, ocasionalmente, sofrer atualizações. Essas atualizações
                são concebidas para melhorar,
                aperfeiçoar e desenvolver os Serviços e podem ser apresentadas sob a forma de correções de erros,
                funções aprimoradas, novos módulos de software e versões completamente novas.
            </li>
            <li>
                <b>2.5.</b> O IMA poderá alterar/revisar periodicamente os Termos de Uso e quando essas alterações forem
                realizadas o usuário compreende
                e concorda que, se utilizar os Serviços após a data de alteração dos Termos de Uso, o IMA considerará
                essa utilização como uma aceitação dos Termos de Uso atualizados.
            </li>
        </ul>
        <ul>
            <p>
                <strong>3. Coleta e uso de informações</strong>
            </p>
            <p>
                <strong>3.1. Informações pessoais</strong>
            </p>
            <p>
                Ao usar nosso serviço não é solicitada nenhuma informação adicional de cadastro do usuário.
                Além disso não é fornecido nenhum formulário para cadastros de usuários.
                <br />
                <br />
                <strong>3.2. Informações Adicionais</strong>
                <br />
                <br />
                Ao usar nosso aplicativo, para fornecer recursos de nosso aplicativo, podemos coletar, com sua permissão
                prévia:

            <ul>
                <li>
                    - Informações sobre sua localização para obter dados do local no App Nossa Praia;
                </li>
            </ul>
            <ul>
                <li>
                    Usamos essas informações para fornecer recursos de Nosso Serviço, para melhorar e personalizar Nosso
                    Serviço.
                </li>
                <li>
                    Você pode habilitar ou desabilitar o acesso a essas informações a qualquer momento, por meio das
                    configurações do seu dispositivo.
                </li>
            </ul>
            </p>
            <div>
                <p><strong>3.3 Serviços de terceiros</strong></p>

                <p>
                    O aplicativo usa serviços de terceiros que podem coletar
                    informações usadas para identificá-lo.
                </p>
                <p>
                    Link para a política de privacidade de provedores de serviços terceirizados usados pelo aplicativo:
                </p>
                <p>
                    <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Google Play
                        Services</a>
                </p>
            </div>
            <div>
                <p><strong>3.4 Delete seus dados</strong></p>

                <p>
                    Você tem o direito de excluir ou solicitar que ajudemos a excluir os Dados Pessoais que coletamos sobre
                    você.
                </p>
                <p>
                    Nosso serviço pode permitir que você exclua certas informações sobre você de dentro do serviço.
                </p>
                <p>
                    Você também pode em contato conosco para solicitar acesso, corrigir ou excluir qualquer informação
                    pessoal que você nos forneceu.
                </p>
                <p>
                    Observe, no entanto, que podemos precisar reter certas informações quando tivermos uma obrigação legal
                    ou base legal para fazê-lo.
                </p>
                <p>
                    A solicitação de exclusão de dados pode ser feita através dos contatos oficiais do IMA/AL,
                    disponíveis na página do IMA/AL: <a
                        href="https://www2.ima.al.gov.br/fale-conosco/ ">https://www2.ima.al.gov.br/fale-conosco/ </a>
                </p>
            </div>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'LegalTermsImaPlus',
};
</script>

<style scoped lang="scss">
ul {
    list-style: none;
}

ul li {
    margin: 10px 0;
}
</style>
